import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
// @ts-ignore
import router from './router/index.js'
import store from './store'
import vuetify from './plugins/vuetify'
import VueMeta from "vue-meta"
import { VueReCaptcha } from 'vue-recaptcha-v3'
import { isRecaptchaConfigured, recaptchaSiteKey } from '@/config/recaptcha'

Vue.config.productionTip = false
Vue.use(VueMeta)
if (isRecaptchaConfigured) {
  Vue.use(VueReCaptcha, { siteKey: recaptchaSiteKey })
}

new Vue({
  // @ts-ignore
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
